// Styles for MerchandisingCardTile go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledMerchandisingCardTile = styled.div`
  .merchandising-card-tile {
    width: 100%;
    &.arrow-icon {
      position: relative;
      overflow: hidden;
      &[class*='icon-arrow-']:before {
        position: absolute;
        right: ${toRem(24)};
        bottom: ${toRem(24)};
        z-index: 1;
      }
    }

    &.inverse {
      .merchandising-card-tile__container__content__card-texts {
        background: ${baseVariables.gradient['baseGradient04']};
      }
    }
    &.standard {
      .merchandising-card-tile__container__content__card-texts {
        background: ${baseVariables.gradient['baseGradient00']};
      }
    }
    &__container {
      position: relative;
      border-radius: ${toRem(14)};
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      height: fit-content;

      &__overlay {
        position: absolute;
        left: 0;
        top: 0;
        &__badge {
          background: ${baseVariables.color['neutral10']};
        }
      }

      &__image {
        width: 100%;
        &-square {
          object-fit: cover;
        }
      }

      &__content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        &__card-texts {
          background: ${baseVariables.gradient['baseGradient04']};
          width: 100%;
          white-space: normal;
          &__logo {
            max-width: ${toRem(78)};
          }
        }
      }
    }
    &__square-image {
      width: 100%;
      aspect-ratio: 1 / 1;
      border-radius: ${toRem(14)};
    }
    &__wide-image {
      width: 100%;
      aspect-ratio: 16 / 9;
      border-radius: ${toRem(14)};
    }
  }
  .icon-arrow-left-external:hover::before,
  .icon-arrow-left-external.focus-visible::before {
    transform: rotate(45deg);
    transition: 0.15s all ease-in;
  }
`;
